__webpack_public_path__ = window.__webpack_public_path__;

import '../styles/main.scss';
import smoothscroll from 'smoothscroll-polyfill';
import Theme from './Theme';

smoothscroll.polyfill();

let theme = new Theme();
theme.mountComponents();

document.addEventListener('shopify:section:unload', (e) => {
    theme.unmountComponents(e.target);
});

document.addEventListener('shopify:section:load', (e) => {
    theme.mountComponents(e.target);
    theme._ctx.emit('bb--lazy-load-update');
});

window.addToCart = function (product_id, id) {
    document.addToCartForm.id.value = id;

    document.addToCartForm.id.setAttribute('data-productid', product_id);
    document.addToCartForm.setAttribute('data-productid', product_id);
    document.addToCartForm.setAttribute('id', `quick-add-${product_id}`);

    document.addToCartForm.submit();
};
